var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4021 5.0717L9.26859 0.938208C8.01475 -0.312411 5.98527 -0.312411 4.73142 0.938208L0.597932 5.0717C0.213808 5.45377 -0.00149608 5.97363 7.82594e-06 6.51545V12.5693C0.00129298 13.3595 0.641901 13.9995 1.43211 14.0002H12.5679C13.3581 13.9996 13.9987 13.3595 14 12.5693V6.51545C14.0015 5.97363 13.7862 5.45377 13.4021 5.0717ZM12.25 12.2502H9.33334V10.394C9.33334 9.16398 8.3362 8.16684 7.10617 8.16684H6.89385C5.66382 8.16684 4.66667 9.16398 4.66667 10.394V12.2502H1.75V6.51545C1.7502 6.43809 1.78077 6.36394 1.83518 6.30895L5.96867 2.17546C6.5381 1.60586 7.46147 1.60575 8.03107 2.17518C8.03115 2.17526 8.03126 2.17537 8.03134 2.17546L12.1648 6.30895C12.2192 6.36394 12.2498 6.43809 12.25 6.51545V12.2502H12.25Z",
    fill: "#67686D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f64ae75a932efd4dea5394479791c50d.svg";
export { ForwardRef as ReactComponent };